import { ETSY_URL, LOGO_URL, HERO_BG_URL, trackEtsy } from "../data/site";
import { ArrowUpRight, ChevronDown } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden flex items-center justify-center"
    >
      {/* Background texture */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0 kenburns"
          style={{
            backgroundImage: `url(${HERO_BG_URL})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            opacity: 0.55,
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0B]/85 via-[#0B0B0B]/65 to-[#0B0B0B]" />
        <div className="absolute inset-0 grain-overlay" />
      </div>

      {/* Side ornaments */}
      <div className="hidden lg:flex absolute left-8 top-1/2 -translate-y-1/2 z-10">
        <span className="vertical-rl text-[10px] tracking-[0.45em] uppercase text-[#D4AF37]/70">
          Est. Melbourne — Curated from Africa
        </span>
      </div>
      <div className="hidden lg:flex absolute right-8 top-1/2 -translate-y-1/2 z-10">
        <span className="vertical-rl text-[10px] tracking-[0.45em] uppercase text-white/40">
          № 01 / Heritage Edit
        </span>
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 max-w-6xl mx-auto text-center reveal">
        <div className="flex justify-center mb-8 md:mb-10">
          <img
            src={LOGO_URL}
            alt="Kendi Collections"
            className="w-[260px] sm:w-[340px] md:w-[440px] lg:w-[500px] h-auto object-contain drop-shadow-[0_0_40px_rgba(212,175,55,0.18)]"
            data-testid="hero-logo"
          />
        </div>

        <div className="flex items-center justify-center gap-4 mb-7">
          <span className="h-px w-10 sm:w-16 bg-[#D4AF37]/60" />
          <p
            data-testid="hero-tagline"
            className="text-[11px] sm:text-xs md:text-sm tracking-[0.42em] uppercase text-[#D4AF37] font-medium"
          >
            African Heritage <span className="text-white/40 mx-2">•</span> Handmade{" "}
            <span className="text-white/40 mx-2">•</span> Timeless
          </p>
          <span className="h-px w-10 sm:w-16 bg-[#D4AF37]/60" />
        </div>

        <h1 className="font-serif-display text-[28px] sm:text-4xl md:text-5xl lg:text-6xl text-white/90 leading-[1.15] tracking-tight max-w-3xl mx-auto italic font-light">
          Where the soul of Africa <br className="hidden sm:block" />
          finds a place in your home.
        </h1>

        <div className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-4 items-center justify-center">
          <a
            href={ETSY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEtsy("heritage_hero")}
            data-testid="hero-shop-etsy-btn"
            className="btn-gold"
          >
            <span>Shop Now on Etsy</span>
            <ArrowUpRight className="w-4 h-4" />
          </a>
          <a
            href="#story"
            data-testid="hero-explore-link"
            className="text-[11px] tracking-[0.28em] uppercase text-white/70 hover:text-[#D4AF37] transition-colors duration-300 inline-flex items-center gap-2 px-2 py-2"
          >
            Discover the story
            <ChevronDown className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>

      {/* Bottom marquee strip */}
      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-white/5 bg-[#0B0B0B]/70 backdrop-blur-md py-3 overflow-hidden marquee-mask">
        <div className="flex marquee-track whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, dup) => (
            <div key={dup} className="flex items-center gap-12 pr-12 shrink-0">
              {[
                "Maasai Shuka",
                "Handwoven Baskets",
                "Beaded Jewellery",
                "Wooden Carvings",
                "African Art",
                "Curated in Melbourne",
                "Sourced from East Africa",
              ].map((t, i) => (
                <span
                  key={`${dup}-${i}`}
                  className="text-[10px] sm:text-xs tracking-[0.42em] uppercase text-white/55 flex items-center gap-12"
                >
                  {t}
                  <span className="text-[#D4AF37]">◆</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
